import React from 'react'

import styled from 'styled-components'

import { useCompanyCopies } from 'core/hooks'
import variables from 'core/styles/variables'

const Disclosures = styled.div`
  flex-grow: 1;
  align-self: flex-start;
  padding-bottom: 16px;
`

const Content = styled.div`
  width: 100%;
  font-size: 12px;
  line-height: 24px;
  color: ${variables.colorBlack70};
  white-space: pre-wrap;

  a {
    color: ${variables.colorBluePrimary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

const FooterDisclosures = () => {
  const { disclosures } = useCompanyCopies()

  const disclosuresHtml = { __html: disclosures }

  return <Disclosures>{disclosures && <Content dangerouslySetInnerHTML={disclosuresHtml} />}</Disclosures>
}

export default FooterDisclosures
